//import Accordion from "@bsw/nightingale";
import React, { useState, useEffect } from 'react';
import { AccordionItem, Divider } from '../../index'
import './accordion.scss';

export const Accordion = ({
    accordionItems,
    ariaLabelCollapsed,
    ariaLabelExpanded,
    borderStyle,
    children,
    openIndex,
    toggle = () => { },
}) => {

    const isOpen = (index) => {
        if (openIndex !== "" || openIndex !== undefined) {
            return openIndex === index;
        } else {
            return false;
        }
    }

    return <div className="bsw-accordion">
        {children
            ? <>
                {children}
            </>
            : <>
                {accordionItems && accordionItems.map((item, index) => {
                    return <React.Fragment key={index}>
                        <AccordionItem
                            data-key={index}
                            disabled={item?.disabled}
                            headerAs={item?.headerAs}
                            heading={item?.heading}
                            className={item?.className}
                            content={item?.content}
                            open={isOpen(`${index}`)}
                            toggle={(e) => toggle(e, `${index}`)}
                        />
                        {(index < accordionItems.length - 1) && <Divider mLeft="none" mRight="none" />}
                     </React.Fragment>
                })}
            </>
        }
    </div>;
}